import React from 'react';
import PropTypes from 'prop-types';

import { isMobileUA } from 'dpl/shared/utils';
import {
  BREEDER_MISSION_DISPLAY_TYPE,
  GENERAL_MISSION_DISPLAY_TYPE
} from 'dpl/prismic/article/mission_callout/utils/constants';
import Icon from 'dpl/common/components/Icon';
import PrismicBreederMissionContent from 'dpl/prismic/article/mission_callout/components/BreederMissionContent';
import PrismicBuyerMissionContent from 'dpl/prismic/article/mission_callout/components/BuyerMissionContent';

const ICON_WIDTH = isMobileUA() ? '64px' : '96px';

export default function Mission({ feature }) {
  return (
    <div className="PrismicMission">
      <div className="flex">
        <Icon
          className="PrismicMission__icon mb3 mb0-sm mr5-sm mr3-lg mr5-xl"
          name="gooddogavatar"
          height={ICON_WIDTH}
          width={ICON_WIDTH}
        />
        <div className="f2 fw-medium">
          {feature === BREEDER_MISSION_DISPLAY_TYPE ? (
            <PrismicBreederMissionContent />
          ) : (
            <PrismicBuyerMissionContent />
          )}
        </div>
      </div>
    </div>
  );
}

Mission.propTypes = {
  feature: PropTypes.oneOf([
    BREEDER_MISSION_DISPLAY_TYPE,
    GENERAL_MISSION_DISPLAY_TYPE
  ]).isRequired
};
